import { render, staticRenderFns } from "./minelists.vue?vue&type=template&id=b46bb546&"
import script from "./minelists.vue?vue&type=script&lang=js&"
export * from "./minelists.vue?vue&type=script&lang=js&"
import style0 from "./minelists.vue?vue&type=style&index=0&id=b46bb546&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports